<template lang="pug">
  .scheduled-debt
    cp-card-info(
      iconName="logo-bb"
      text="<strong>Esse método de pagamento é válido apenas para clientes Banco do Brasil</strong>"
    )

    .scheduled-debt__row
      cp-field(
        label="Nome completo"
        for="name"
        id="name"
        type="text"
        name="name"
        placeholder="Ex: João Oliveira da Silva"
        :value="holderName"
        :validation="nameValidation"
        @change="setName"
      )

      cp-field(
        label="CPF do titular"
        for="cpf"
        id="cpf"
        type="tel"
        name="cpf"
        placeholder="Somente números"
        :mask="['###.###.###-##']"
        :value="holderCPF"
        :validation="CPFValidation"
        @change="setCPF"
      )

    .scheduled-debt__row.checkbox(v-if="personalData.name && personalData.cpf")
      input.checkbox__input(
        v-model="canCopyPersonalData"
        type='checkbox'
        id="canCopyPersonalData"
        name="canCopyPersonalData"
        value="true"
      )
      label.checkbox__label(for="canCopyPersonalData") Mesmo nome e CPF informados anteriormente

    .scheduled-debt__row
      cp-field(
        label="Agência"
        lblInfo="(sem digito)"
        for="agency"
        id="agency"
        type="tel"
        name="agency"
        placeholder="Somente números"
        :mask="['####']"
        :value="agency"
        :validation="agencyValidation"
        @change="setAgency"
      )

      cp-field(
        label="Conta"
        lblInfo="(sem digito)"
        for="account"
        id="account"
        type="tel"
        name="account"
        placeholder="Somente números"
        :mask="['#####']"
        :value="account"
        :validation="accountValidation"
        @change="setAccount"
      )
</template>
<script>
import views from '@/mixins/views'
import { CPF } from 'cpf_cnpj'
import { helpers, minLength, maxLength, required } from 'vuelidate/lib/validators'

import cpCardInfo from '@/components/molecules/CardInfo.vue'
import cpField from '@/components/molecules/Field.vue'

export default {
  name: 'ScheduledDebt',
  mixins: [views],
  props: {
    personalData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      name: null,
      cpf: null,
      agency: null,
      account: null,
      installment: 1,
      canCopyPersonalData: false
    }
  },
  components: {
    cpCardInfo,
    cpField
  },
  computed: {
    holderName () {
      return this.canCopyPersonalData ? this.personalData.name : this.name
    },
    holderCPF () {
      return this.canCopyPersonalData ? this.personalData.cpf : this.cpf
    },
    nameValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Informe seu nome e sobrenome',
          valid: false
        }
      ]

      if (!this.$v.name.$invalid) return { valid: true }
      if (this.$v.name.$dirty && this.$v.name.$invalid) return validations[0]

      return {}
    },
    CPFValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Por favor, insira um CPF',
          valid: false
        },
        {
          type: 'error',
          msg: 'CPF Inválido',
          valid: false
        },
        {
          msg: 'Verificando CPF...'
        }
      ]

      if (!this.$v.cpf.$invalid && this.cpf.length === 11) return { valid: true }
      if (this.$v.cpf.$dirty && this.$v.cpf.$invalid) {
        if (!this.$v.cpf.required) return validations[0]
        if (!this.$v.cpf.cpfValidator && this.$v.cpf.required) return validations[1]
        if (this.$v.cpf.cpfValidator && this.$v.cpf.$pending) return validations[3]
      }

      return {}
    },
    agencyValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Agência inválido',
          valid: false
        }
      ]

      if (!this.$v.agency.$invalid && this.agency.length >= 1) { return { valid: true } }
      if (this.$v.agency.$dirty && this.$v.agency.$invalid) { return validations[0] }

      return {}
    },
    accountValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Conta inválido',
          valid: false
        }
      ]

      if (!this.$v.account.$invalid && this.account.length >= 5) { return { valid: true } }
      if (this.$v.account.$dirty && this.$v.account.$invalid) { return validations[0] }

      return {}
    }
  },
  methods: {
    setName (value) {
      this.name = value
      this.setDirty(this.$v.name)
      this.outinput()
    },
    setCPF (value) {
      this.cpf = value
      this.setDirty(this.$v.cpf)
      this.outinput()
    },
    setAgency (value) {
      this.agency = value
      this.setDirty(this.$v.agency)
      this.outinput()
    },
    setAccount (value) {
      this.account = value
      this.setDirty(this.$v.account)
      this.outinput()
    },
    outinput () {
      this.$emit('outinput', {
        data: {
          name: this.name,
          cpf: this.cpf,
          agency: this.agency,
          account: this.account
        },
        installment: this.installment,
        isValid: !this.$v.$invalid
      })
    }
  },
  validations: {
    name: {
      required,
      alphaWhiteDiacritic: helpers.regex('alphaWhiteDiacritic', /^[a-zA-ZÀ-ž.\s]*$/),
      fullName: helpers.regex('fullName', /.{2,}\s.{2,}/),
      blackListName: (value) => !(/((^|\s)((teste|test)(s)?)(\s|$))/i.test(value))
    },
    cpf: {
      required,
      cpfValidator: (value) => CPF.isValid(value)
    },
    agency: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(4)
    },
    account: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(5)
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/style/_variables";

  .scheduled-debt {
    &__row {
      position: relative;
      width: 100%;

      @media screen and (min-width: 768px) {
        display: flex;
        justify-content: flex-start;
      }
    }
  }

  .checkbox {
    margin-top: 17px;

    &__input {
      position: absolute;
      left: -9999px;

      & + label {
        color: #595959;
        cursor: pointer;
        display: inline-block;
        font-family: $rubik-font-family;
        font-size: 14px;
        line-height: 1.57;
        padding-left: 38px;
        position: relative;

        &:before {
          background: url("~@/assets/icons/check-off.svg") center center no-repeat;
          content: '';
          height: 20px;
          left: 0;
          top: -1px;
          position: absolute;
          width: 20px;
        }
      }

      &:checked + label:before {
        background: url("~@/assets/icons/check-on.svg") center center no-repeat;
      }
    }
  }
</style>
